import { ThemeTokens } from '../../tokens';

export const tokenOverwrite = (base: string, entries: Record<string, string | number>): Record<ThemeTokens, string | number> => {
  return Object.entries(entries).reduce((acc, [key, value]) => {
    acc[`--theme--tokens--${base}--${key}`] = value;
    return acc;
  }, {} as Record<ThemeTokens, string | number>);
};